module.exports = __webpack_public_path__ + "img/logo-footer.b2ac615c.svg";